import { render } from "./DictionaryItemsFilter.vue?vue&type=template&id=48ae23c4&scoped=true"
import script from "./DictionaryItemsFilter.vue?vue&type=script&lang=js"
export * from "./DictionaryItemsFilter.vue?vue&type=script&lang=js"

import "./DictionaryItemsFilter.vue?vue&type=style&index=0&id=48ae23c4&scoped=true&lang=scss"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ae23c4"]])

export default __exports__